/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Abandon_Vekn_DescriptionInputs */



/**
* | output |
* | --- |
* | "Unlinks your VEKN ID. You keep your account and logins; anyone can then claim the ID." |
*
* @param {Profile_Abandon_Vekn_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_abandon_vekn_description = /** @type {((inputs?: Profile_Abandon_Vekn_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Abandon_Vekn_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dissocie votre ID VEKN. Vous gardez votre compte et vos connexions ; l'ID pourra ensuite être revendiqué par n'importe qui.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desvincula su ID VEKN. Conserva su cuenta y sus accesos; cualquiera podrá reclamar el ID después.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desvincula seu ID VEKN. Você mantém sua conta e seus acessos; qualquer pessoa poderá reivindicar o ID depois.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scollega il tuo ID VEKN. Mantieni account e accessi; l'ID potrà poi essere rivendicato da chiunque.")
	return /** @type {LocalizedString} */ ("Unlinks your VEKN ID. You keep your account and logins; anyone can then claim the ID.")
});